import type { Database } from '@inboundx/shared/types';
import { createClient } from '@supabase/supabase-js';

// Preprod-UI uses direct Supabase connection (not proxy) to support OAuth
// Uses VITE_DIRECT_SUPABASE_URL and VITE_DIRECT_SUPABASE_ANON_KEY for direct connection
const supabaseUrl = import.meta.env.VITE_DIRECT_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_DIRECT_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('Supabase URL or Anon Key not configured. Authentication will not work.');
}

// Use dummy values if not configured to prevent client creation errors
const safeUrl = supabaseUrl || 'https://placeholder.supabase.co';
const safeKey = supabaseAnonKey || 'placeholder-key';

export const supabase = createClient<Database>(safeUrl, safeKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: 'playground-auth-token', // Unique storage key to avoid conflicts with shared package
    },
});

// Export a helper to check if Supabase is properly configured
export const isSupabaseConfigured = () => {
    return !!(
        supabaseUrl &&
        supabaseAnonKey &&
        !supabaseUrl.includes('placeholder') &&
        !supabaseAnonKey.includes('placeholder')
    );
};
